/** Small circular progress indicator with a numeric percent label. */
export function UploadProgressRing({ percent }: { percent: number }) {
  const r = 8;
  const c = 2 * Math.PI * r;
  const clamped = Math.min(100, Math.max(0, Math.round(percent)));
  const offset = c * (1 - clamped / 100);

  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      style={{ verticalAlign: "middle", marginRight: 4, flexShrink: 0 }}
      role="img"
      aria-label={`Upload ${clamped} percent`}
    >
      <title>{`Upload ${clamped}%`}</title>
      <circle
        cx="11"
        cy="11"
        r={r}
        fill="none"
        stroke="rgba(255,255,255,0.12)"
        strokeWidth="2.5"
      />
      <circle
        cx="11"
        cy="11"
        r={r}
        fill="none"
        stroke="#7fb3d5"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeDasharray={c}
        strokeDashoffset={offset}
        transform="rotate(-90 11 11)"
      />
      <text
        x="11"
        y="12"
        textAnchor="middle"
        fontSize="6.5"
        fill="var(--vera-text-dim)"
        fontFamily="system-ui, sans-serif"
      >
        {clamped}
      </text>
    </svg>
  );
}
